import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectFlatShare = createSelector(selectJsonQuery, jsonQuery => getTermValue('flat_share')(jsonQuery));
